import { useEffect, useState } from "react";
import { fetchNeedsPhotoCount, fetchPhotoUpdatesEnabled } from "./photoUpdateApi";

let enabledOnce: Promise<boolean> | null = null;

/** Whether photo updates are on (asked once per page load) and how many products need photos. */
export function usePhotoUpdates(refreshKey?: unknown): { enabled: boolean; known: boolean; count: number | null } {
  const [enabled, setEnabled] = useState(false);
  // False until the server has answered, so a saved Needs-photo filter is not dropped while we wait.
  const [known, setKnown] = useState(false);
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    let live = true;
    if (!enabledOnce) enabledOnce = fetchPhotoUpdatesEnabled();
    enabledOnce
      .then(async (on) => {
        if (!live) return;
        setKnown(true);
        if (!on) return;
        setEnabled(true);
        const n = await fetchNeedsPhotoCount();
        if (live) setCount(n);
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [refreshKey]);
  return { enabled, known, count };
}

/** Tests only. */
export function resetPhotoUpdatesCache() {
  enabledOnce = null;
}
